import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CastecategoryRoutingModule } from './castecategory-routing.module';
import { CastecategoryListComponent } from './castecategory-list/castecategory-list.component';
import { CastecategoryCreateComponent } from './castecategory-create/castecategory-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [CastecategoryListComponent, CastecategoryCreateComponent],
  imports: [
    CommonModule,
    CastecategoryRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class CastecategoryModule { }
